export const ACCESS_TOKEN_KEY = "ACCESS_TOKEN";
export const REFRESH_TOKEN_KEY = "REFRESH_TOKEN";
export const ACCESS_EXPIRATION_KEY = "ACCESS_EXPIRATION_KEY";
export const REFRESH_EXPIRATION_KEY = "REFRESH_EXPIRATION_KEY";
export const IS_LOGGED_IN_KEY = "IS_LOGGED_IN";
export const USER_KEY = "USER_KEY";

export const COLOR_VARIANT_ID = 2;

export enum ORDER_STATUS {
  ALL = "all",
  PENDING = "pending",
  APPROVED = "approved",
  SCHEDULED = "scheduled",
  ON_MY_WAY = "on_my_way",
  DELIVERED = "delivered",
  CANCELLED = "cancelled",
}

export enum PAYMENT_STATUS {
  ALL = "all",
  PENDING = "pending",
  FAILED = "failed",
  COMPLETED = "completed",
}
